import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ArtificialIntelligenceService { 

    constructor(private http: HttpClient) { }

    getaiService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_artificial_intelligence`);
    }    	    
}
